import { render, staticRenderFns } from "./ConversationAvatar.vue?vue&type=template&id=46791782&"
import script from "./ConversationAvatar.vue?vue&type=script&lang=js&"
export * from "./ConversationAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports